import { combineEpics, Epic } from 'redux-observable';

import { Action } from '../actions';
import { changeLocation } from '../actions/common';
import {
    LOG_NAVIGATION_GO_TO_ENTITY,
    LOG_NAVIGATION_GO_TO_FILTER_WITH_CID_REMOVE,
    LOG_NAVIGATION_GO_TO_LOG_PERIOD_URL,
    LogNavigationGoToEntityAction,
    LogNavigationGoToFilterWithCidRemoveAction,
    LogNavigationGoToLogPeriodUrlAction
} from '../actions/log-navigation';
import { getLogCriteria } from '../declarations/log-filters/log-filters';
import { serializeFilterToString } from '../service/FilterHelpers/FilterHelpers';
import { LogHelpers } from '../service/LogHelpers/LogHelpers';
import { EpicDeps } from '../service/StoreFactory';
import { UrlHelpers } from '../service/UrlHelpers';
import { FilterPartialExpression } from '../typings/filter';
import { LogScreenUrlSearchParams } from '../typings/log';
import { State } from '../typings/state';

export const logNavigationGoToFilterWithCidRemoveEpic: Epic<
    Action,
    Action,
    State,
    EpicDeps
> = (action$, store$) => {
    return action$
        .ofType(LOG_NAVIGATION_GO_TO_FILTER_WITH_CID_REMOVE)
        .map((action: LogNavigationGoToFilterWithCidRemoveAction) => {
            const { pathname, query = {} } = store$.value.router;

            const criteria = getLogCriteria(),
                campaignIdField = (
                    criteria.find(item => {
                        return item.key === 'cid';
                    }) || { title: 'cid' }
                ).title,
                hasClientIdInExpressions = action.expressions.reduce(
                    (res: boolean, expr: FilterPartialExpression) => {
                        return res || expr.field === campaignIdField;
                    },
                    false
                ),
                cid = query.cid;

            return changeLocation(
                pathname,
                UrlHelpers.normalizeQuery({
                    [LogScreenUrlSearchParams.filter]: serializeFilterToString(
                        action.expressions
                    ),
                    [LogScreenUrlSearchParams.cid]: hasClientIdInExpressions
                        ? cid === null
                            ? undefined
                            : cid
                        : ''
                })
            );
        });
};

export const logNavigationGoToLogPeriodUrlEpic: Epic<
    Action,
    Action,
    State,
    EpicDeps
> = (action$, store$) => {
    return action$
        .ofType(LOG_NAVIGATION_GO_TO_LOG_PERIOD_URL)
        .map((action: LogNavigationGoToLogPeriodUrlAction) => {
            const { pathname } = store$.value.router;
            const { dateFrom, dateTo, dateRangePreset } = action.period;

            return changeLocation(
                pathname,
                UrlHelpers.normalizeQuery({
                    [LogScreenUrlSearchParams.datePreset]:
                        dateFrom && dateTo ? '' : (dateRangePreset as string),
                    [LogScreenUrlSearchParams.dateFrom]: dateFrom
                        ? dateFrom.format('YYYY-MM-DD')
                        : '',
                    [LogScreenUrlSearchParams.dateTo]: dateTo
                        ? dateTo.format('YYYY-MM-DD')
                        : ''
                })
            );
        });
};

export const logNavigationGoToEntityEpic: Epic<
    Action,
    Action,
    State,
    EpicDeps
> = (action$, store$) => {
    return action$
        .ofType(LOG_NAVIGATION_GO_TO_ENTITY)
        .map((action: LogNavigationGoToEntityAction) => {
            const {
                router: { pathname },
                log: {
                    sourceParams: { filter }
                }
            } = store$.value;
            const criteria = getLogCriteria();
            const logExpression = LogHelpers.parseEntities(
                criteria,
                action.params
            );

            return changeLocation(
                pathname,
                UrlHelpers.normalizeQuery({
                    [LogScreenUrlSearchParams.filter]: serializeFilterToString(
                        logExpression.concat(filter || [])
                    )
                })
            );
        });
};

export const logNavigationEpic = combineEpics(
    logNavigationGoToFilterWithCidRemoveEpic,
    logNavigationGoToLogPeriodUrlEpic,
    logNavigationGoToEntityEpic
);
